/**
 * Vegenergy Consent Manager v0.3.0
 * Shopify-Integration für Vegenergy Theme v1.7.3
 *
 * Ein zentraler Consent-Status für vegenergy.at und alle Subdomains.
 * Nicht notwendige Ressourcen müssen zusätzlich mit
 * data-vegenergy-consent markiert werden. Siehe README.md.
 */

(function () {
  "use strict";

  var CONSENT_VERSION = 1;
  var COOKIE_NAME = "vegenergy_consent_v1";
  var COOKIE_MAX_AGE = 60 * 60 * 24 * 180;
  var COOKIE_DOMAIN = ".vegenergy.at";
  var PRIVACY_URL = "https://www.vegenergy.at/datenschutz";
  var IMPRINT_URL = "https://www.vegenergy.at/impressum";
  var SCRIPT_URL =
    document.currentScript && document.currentScript.src
      ? document.currentScript.src
      : "";

  var CATEGORIES = [
    {
      id: "necessary",
      title: "Technisch notwendige Technologien",
      badge: "Immer aktiv",
      required: true,
      summary:
        "Erforderlich für Sicherheit, Navigation, Warenkorb, Anmeldung, " +
        "Formulare und das Speichern deiner Datenschutzentscheidung.",
      purpose:
        "Sicherer Betrieb der Website und Bereitstellung ausdrücklich " +
        "gewünschter Funktionen.",
      legal:
        "§ 165 Abs. 3 TKG 2021; soweit personenbezogene Daten verarbeitet " +
        "werden, insbesondere Art. 6 Abs. 1 lit. b, c oder f DSGVO.",
      storage:
        "Sitzungsbezogen oder funktionsabhängig. Die Vegenergy-" +
        "Datenschutzentscheidung wird höchstens 180 Tage gespeichert.",
      services: [
        {
          name: "Vegenergy Consent Manager",
          host: "alle Vegenergy-Websites",
          description:
            "Speichert ausschließlich die ausgewählten Kategorien, Version " +
            "und Zeitpunkt der Entscheidung als gemeinsames First-Party-Cookie.",
        },
        {
          name: "Shopify Kernfunktionen",
          host: "shop.vegenergy.at",
          description:
            "Warenkorb, Checkout, Kundenkonto, Betrugsprävention, Sicherheit " +
            "und technisch erforderliche Shop-Sitzungen.",
        },
        {
          name: "Vegenergy Seitenbetrieb",
          host: "www, blog, now und finder",
          description:
            "Auslieferung der angeforderten Seite, Sicherheitsfunktionen, " +
            "Formularzustände und technisch notwendige Serverkommunikation.",
        },
      ],
    },
    {
      id: "preferences",
      title: "Personalisierung & Komfort",
      badge: "Freiwillig",
      required: false,
      summary:
        "Merkt sich freiwillige Einstellungen und macht deinen nächsten " +
        "Besuch komfortabler, ohne ein werbliches Profil anzulegen.",
      purpose:
        "Speicherung von Sprache, Region, Darstellungs- und " +
        "Komforteinstellungen sowie freiwilligen Funktionszuständen.",
      legal:
        "Deine Einwilligung gemäß § 165 Abs. 3 TKG 2021 und Art. 6 Abs. 1 " +
        "lit. a DSGVO.",
      storage:
        "Je nach Einstellung für die Sitzung oder bis zum Widerruf; " +
        "anbieterspezifische Laufzeiten stehen in der Datenschutzerklärung.",
      services: [
        {
          name: "Sprach- und Regionsauswahl",
          host: "alle Vegenergy-Websites",
          description:
            "Merkt sich freiwillig gewählte Sprache, Land, Währung oder " +
            "regionale Darstellung.",
        },
        {
          name: "Shopify Personalisierung",
          host: "shop.vegenergy.at",
          description:
            "Übermittelt die Kategorie „preferences“ an Shopifys offizielle " +
            "Customer Privacy API.",
        },
        {
          name: "Optionale Bedienfunktionen",
          host: "je nach Website",
          description:
            "Speichert freiwillige UI-Zustände, beispielsweise geschlossene " +
            "Hinweise oder bevorzugte Darstellungen.",
        },
      ],
    },
    {
      id: "analytics",
      title: "Statistik & Analyse",
      badge: "Freiwillig",
      required: false,
      summary:
        "Hilft uns zu verstehen, welche Seiten und Funktionen genutzt werden. " +
        "Diese Kategorie bleibt ohne deine Zustimmung blockiert.",
      purpose:
        "Reichweitenmessung, Fehleranalyse, Verbesserung von Inhalten, " +
        "Navigation, Shop und technischen Abläufen.",
      legal:
        "Deine Einwilligung gemäß § 165 Abs. 3 TKG 2021 und Art. 6 Abs. 1 " +
        "lit. a DSGVO.",
      storage:
        "Anbieterspezifisch. Konkrete Messkennungen und Laufzeiten müssen in " +
        "der jeweils aktuellen Datenschutzerklärung ausgewiesen werden.",
      services: [
        {
          name: "Google Analytics / Google Tag",
          host: "www.vegenergy.at und shop.vegenergy.at",
          description:
            "Misst Seitenaufrufe und Interaktionen. Eine Übermittlung an " +
            "Google-Dienste kann dabei nicht ausgeschlossen werden.",
        },
        {
          name: "Shopify Analytics",
          host: "shop.vegenergy.at",
          description:
            "Shop- und Nutzungsanalyse. Die Entscheidung wird mit Shopifys " +
            "Customer Privacy API synchronisiert.",
        },
        {
          name: "Cloudflare Web Analytics",
          host: "www, blog, now und finder",
          description:
            "Technische Reichweiten- und Leistungsanalyse über den derzeit " +
            "eingebundenen Cloudflare-Insights-Dienst.",
        },
      ],
    },
    {
      id: "marketing",
      title: "Marketing & Werbung",
      badge: "Freiwillig",
      required: false,
      summary:
        "Ermöglicht Erfolgsmessung von Kampagnen, Wiedererkennung und " +
        "personalisierte Werbung auf anderen Plattformen.",
      purpose:
        "Kampagnenmessung, Conversion-Zuordnung, Zielgruppenbildung und " +
        "interessenbezogene Werbung.",
      legal:
        "Deine Einwilligung gemäß § 165 Abs. 3 TKG 2021 und Art. 6 Abs. 1 " +
        "lit. a DSGVO.",
      storage:
        "Anbieterspezifisch. Drittanbieter können Daten auch außerhalb des " +
        "EWR verarbeiten; Details und Garantien gehören in die Datenschutzerklärung.",
      services: [
        {
          name: "Meta Pixel",
          host: "shop.vegenergy.at",
          description:
            "Misst Kampagnenerfolge und kann Besuche mit Meta-Diensten wie " +
            "Facebook oder Instagram in Verbindung bringen.",
        },
        {
          name: "Google Ads / DoubleClick",
          host: "shop.vegenergy.at",
          description:
            "Conversion-Messung, Kampagnenzuordnung und gegebenenfalls " +
            "personalisierte Werbung über Google.",
        },
        {
          name: "Shopify Marketing",
          host: "shop.vegenergy.at",
          description:
            "Übermittelt die Marketingentscheidung an Shopifys offizielle " +
            "Customer Privacy API und die daran angeschlossenen Pixel.",
        },
      ],
    },
    {
      id: "external",
      title: "Externe Medien, Karten & Suche",
      badge: "Freiwillig",
      required: false,
      summary:
        "Lädt Inhalte von externen Anbietern erst nach deiner Freigabe oder " +
        "nach einer bewussten Einzelaktion.",
      purpose:
        "Darstellung von Karten, Videos, externer Suche, Standortabfragen und " +
        "eingebetteten Inhalten.",
      legal:
        "Deine Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO; soweit dabei auf " +
        "das Endgerät zugegriffen wird, zusätzlich § 165 Abs. 3 TKG 2021.",
      storage:
        "Abhängig vom aufgerufenen Anbieter. Bereits der Abruf kann IP-Adresse, " +
        "Browser- und Verbindungsdaten an den externen Anbieter übermitteln.",
      services: [
        {
          name: "OpenStreetMap Nominatim",
          host: "finder.vegenergy.at",
          description:
            "Geocodierung und Ortssuche. Der Abruf kann technische " +
            "Verbindungsdaten an die OpenStreetMap-Infrastruktur übertragen.",
        },
        {
          name: "CARTO Kartenkacheln",
          host: "finder.vegenergy.at",
          description:
            "Lädt die sichtbaren Kartenkacheln. Dabei wird eine Verbindung zu " +
            "den CARTO-CDN-Servern hergestellt.",
        },
        {
          name: "Leaflet über unpkg",
          host: "finder.vegenergy.at",
          description:
            "Lädt derzeit die Kartenbibliothek von einem externen CDN. " +
            "Datenschutzfreundlicher ist eine lokale Bereitstellung.",
        },
        {
          name: "Externe Videos und Einbettungen",
          host: "je nach Website",
          description:
            "Lädt Videos, Social-Media-Inhalte oder weitere Embeds erst nach " +
            "Freigabe beziehungsweise aktivem Klick.",
        },
        {
          name: "Ghost-Suche über jsDelivr",
          host: "blog.vegenergy.at",
          description:
            "Stellt die Blogsuche über ein extern ausgeliefertes Skript bereit. " +
            "Eine lokale Bereitstellung wäre datensparsamer.",
        },
      ],
    },
  ];

  var currentHostname = getHostname();
  var isShop = currentHostname === "shop.vegenergy.at";
  var isActualShop = window.location.hostname === "shop.vegenergy.at";
  var banner = null;
  var settingsDrawer = null;
  var observer = null;
  var currentState = null;
  var statusTimer = null;
  var suppressSettingsOnClose = false;
  var CONSENT_UI_CLASS = "veg-consent-ui-open";
  var CONSENT_STATUS_CLASS = "veg-consent-status-open";

  function setConsentUiOpen(isOpen) {
    document.documentElement.classList.toggle(
      CONSENT_UI_CLASS,
      isOpen === true
    );
  }

  function getHostname() {
    var host = window.location.hostname;

    if (
      host === "localhost" ||
      host === "127.0.0.1" ||
      host.indexOf(".local") !== -1
    ) {
      try {
        var demo = new URLSearchParams(window.location.search).get("demo");
        if (demo) return demo;
      } catch (_) {}
    }

    return host;
  }

  function isLocalPreview() {
    var host = window.location.hostname;
    return (
      host === "localhost" ||
      host === "127.0.0.1" ||
      host.indexOf(".local") !== -1
    );
  }

  function isVegenergyHost() {
    var actualHost = window.location.hostname;
    return (
      actualHost === "vegenergy.at" ||
      actualHost.slice(-13) === ".vegenergy.at"
    );
  }

  function getAssetBase() {
    try {
      return SCRIPT_URL
        ? new URL(".", SCRIPT_URL).href
        : "";
    } catch (_) {
      return "";
    }
  }

  function createElement(tag, classes, text) {
    var element = document.createElement(tag);
    if (classes) element.className = classes;
    if (text !== undefined && text !== null) element.textContent = text;
    return element;
  }

  function defaultCategories(value) {
    return {
      necessary: true,
      preferences: !!value,
      analytics: !!value,
      marketing: !!value,
      external: !!value,
    };
  }

  function normalizeState(raw) {
    if (!raw || raw.version !== CONSENT_VERSION || !raw.categories) {
      return null;
    }

    return {
      version: CONSENT_VERSION,
      updatedAt: raw.updatedAt || null,
      categories: {
        necessary: true,
        preferences: raw.categories.preferences === true,
        analytics: raw.categories.analytics === true,
        marketing: raw.categories.marketing === true,
        external: raw.categories.external === true,
      },
    };
  }

  function readConsent() {
    try {
      var prefix = COOKIE_NAME + "=";
      var parts = document.cookie ? document.cookie.split(";") : [];

      for (var i = 0; i < parts.length; i++) {
        var part = parts[i].trim();
        if (part.indexOf(prefix) === 0) {
          var parsed = JSON.parse(decodeURIComponent(part.slice(prefix.length)));
          return normalizeState(parsed);
        }
      }
    } catch (_) {}

    return null;
  }

  function writeConsent(state) {
    var value = encodeURIComponent(JSON.stringify(state));
    var cookie =
      COOKIE_NAME +
      "=" +
      value +
      "; Path=/; Max-Age=" +
      COOKIE_MAX_AGE +
      "; SameSite=Lax";

    if (isVegenergyHost()) cookie += "; Domain=" + COOKIE_DOMAIN;
    if (window.location.protocol === "https:") cookie += "; Secure";

    document.cookie = cookie;
  }

  function deleteConsent() {
    var cookie =
      COOKIE_NAME + "=; Path=/; Max-Age=0; SameSite=Lax";

    if (isVegenergyHost()) cookie += "; Domain=" + COOKIE_DOMAIN;
    if (window.location.protocol === "https:") cookie += "; Secure";

    document.cookie = cookie;
  }

  function buildState(categories) {
    return {
      version: CONSENT_VERSION,
      updatedAt: new Date().toISOString(),
      categories: {
        necessary: true,
        preferences: categories.preferences === true,
        analytics: categories.analytics === true,
        marketing: categories.marketing === true,
        external: categories.external === true,
      },
    };
  }

  function showStatus(message) {
    var oldStatus = document.querySelector(".veg-consent-status");
    if (oldStatus && oldStatus.parentNode) {
      oldStatus.parentNode.removeChild(oldStatus);
    }

    if (statusTimer) window.clearTimeout(statusTimer);

    var status = createElement("div", "veg-consent-status", message);
    status.setAttribute("role", "status");
    document.body.appendChild(status);
    document.documentElement.classList.add(CONSENT_STATUS_CLASS);

    statusTimer = window.setTimeout(function () {
      if (status.parentNode) status.parentNode.removeChild(status);
      document.documentElement.classList.remove(CONSENT_STATUS_CLASS);
      statusTimer = null;

      try {
        window.dispatchEvent(
          new CustomEvent("vegenergy:chat-reveal", {
            detail: {
              source: "consent-status-close",
            },
          })
        );
      } catch (_) {}
    }, 4200);
  }

  function setConsent(categories, source) {
    currentState = buildState(categories);
    writeConsent(currentState);
    applyConsent(currentState, source || "settings");
    hideBanner();

    if (settingsDrawer && settingsDrawer.isOpen()) {
      settingsDrawer.close();
    }

    showStatus(
      source === "accept-all"
        ? "Alle optionalen Kategorien wurden aktiviert."
        : source === "reject-all"
          ? "Es bleiben nur technisch notwendige Technologien aktiv."
          : "Deine Datenschutz-Auswahl wurde gespeichert."
    );
  }

  function dispatchConsentEvent(state, source) {
    try {
      document.dispatchEvent(
        new CustomEvent("vegenergy:consent-changed", {
          detail: {
            source: source,
            version: state.version,
            updatedAt: state.updatedAt,
            categories: Object.assign({}, state.categories),
          },
        })
      );
    } catch (_) {}
  }

  function loadShopifyPrivacy(callback) {
    if (!isActualShop || !window.Shopify) {
      callback(null);
      return;
    }

    if (window.Shopify.customerPrivacy) {
      callback(window.Shopify.customerPrivacy);
      return;
    }

    if (typeof window.Shopify.loadFeatures !== "function") {
      callback(null);
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      function (error) {
        callback(
          !error && window.Shopify.customerPrivacy
            ? window.Shopify.customerPrivacy
            : null
        );
      }
    );
  }

  function syncShopifyConsent(state) {
    if (!isActualShop || !state) return;

    var shopifyChoice = {
      preferences: state.categories.preferences,
      analytics: state.categories.analytics,
      marketing: state.categories.marketing,
    };

    loadShopifyPrivacy(function (privacy) {
      if (
        privacy &&
        typeof privacy.setTrackingConsent === "function"
      ) {
        privacy.setTrackingConsent(shopifyChoice, function () {
          document.documentElement.classList.add(
            "vegenergy-consent-manager"
          );
        });
      }
    });
  }

  function getShopifyConsentComparison(privacy, state) {
    if (!privacy || !state) return "pending";

    try {
      var ids = ["preferences", "analytics", "marketing"];
      var registered =
        typeof privacy.currentVisitorConsent === "function"
          ? privacy.currentVisitorConsent()
          : null;
      var hasCompleteMatchingChoice = !!registered;

      for (var i = 0; i < ids.length; i++) {
        var id = ids[i];
        var expected = state.categories[id] ? "yes" : "no";
        var actual = registered ? registered[id] : "";

        if (actual === "yes" || actual === "no") {
          if (actual !== expected) return "mismatch";
        } else {
          hasCompleteMatchingChoice = false;
        }
      }

      return hasCompleteMatchingChoice ? "match" : "pending";
    } catch (_) {
      return "pending";
    }
  }

  function shopifyConsentNeedsConfirmation(privacy, state) {
    if (!privacy || !state) return false;

    var comparison = getShopifyConsentComparison(privacy, state);

    // Vollständig passende offizielle Shopify-Werte sind maßgeblich, auch
    // wenn shouldShowBanner() danach noch kurz oder dauerhaft true meldet.
    if (comparison === "match") return false;
    if (comparison === "mismatch") return true;

    try {
      if (
        typeof privacy.shouldShowBanner === "function" &&
        privacy.shouldShowBanner()
      ) {
        return true;
      }
    } catch (_) {}

    return false;
  }

  function confirmStoredShopifyConsent(privacy, state, attempt) {
    var comparison = getShopifyConsentComparison(privacy, state);

    if (comparison === "match") return;

    if (comparison === "mismatch") {
      showBanner("shopify-confirmation");
      return;
    }

    // Die Shopify-API ist beim Seitenstart bereits vorhanden, liefert ihre
    // gespeicherten yes/no-Werte aber häufig erst einige Millisekunden später.
    // Während dieser Hydratisierung darf kein Banner erzeugt werden.
    if (attempt < 14) {
      window.setTimeout(function () {
        confirmStoredShopifyConsent(privacy, state, attempt + 1);
      }, 150);
      return;
    }

    if (shopifyConsentNeedsConfirmation(privacy, state)) {
      showBanner("shopify-confirmation");
    }
  }

  function initializeShopifyIntegration() {
    loadShopifyPrivacy(function (privacy) {
      if (!privacy) {
        // Shopifys eigener Banner bleibt sichtbar, wenn die API nicht lädt.
        hideBanner();
        return;
      }

      document.documentElement.classList.add("vegenergy-consent-manager");

      if (currentState) {
        confirmStoredShopifyConsent(privacy, currentState, 0);
      }
    });
  }

  function categoryAllowed(category) {
    if (category === "necessary") return true;
    return !!(
      currentState &&
      currentState.categories &&
      currentState.categories[category] === true
    );
  }

  function copyScriptAttributes(source, target) {
    for (var i = 0; i < source.attributes.length; i++) {
      var attribute = source.attributes[i];
      if (
        attribute.name === "type" ||
        attribute.name === "data-src" ||
        attribute.name === "data-vegenergy-consent" ||
        attribute.name === "data-vegenergy-consent-activated"
      ) {
        continue;
      }
      target.setAttribute(attribute.name, attribute.value);
    }
  }

  function activateDeferredResources() {
    var scripts = document.querySelectorAll(
      'script[type="text/plain"][data-vegenergy-consent]'
    );

    for (var i = 0; i < scripts.length; i++) {
      var source = scripts[i];
      var category = source.getAttribute("data-vegenergy-consent");

      if (
        !categoryAllowed(category) ||
        source.getAttribute("data-vegenergy-consent-activated") === "true"
      ) {
        continue;
      }

      source.setAttribute("data-vegenergy-consent-activated", "true");
      var script = document.createElement("script");
      copyScriptAttributes(source, script);

      var deferredSrc = source.getAttribute("data-src");
      if (deferredSrc) script.src = deferredSrc;
      else script.text = source.text || source.textContent || "";

      source.parentNode.replaceChild(script, source);
    }

    var deferredSources = document.querySelectorAll(
      "[data-vegenergy-src][data-vegenergy-consent]"
    );

    for (var j = 0; j < deferredSources.length; j++) {
      var item = deferredSources[j];
      var sourceCategory = item.getAttribute("data-vegenergy-consent");

      if (
        categoryAllowed(sourceCategory) &&
        !item.getAttribute("src")
      ) {
        item.setAttribute("src", item.getAttribute("data-vegenergy-src"));
        item.setAttribute("data-vegenergy-consent-activated", "true");
      }
    }

    var deferredLinks = document.querySelectorAll(
      "[data-vegenergy-href][data-vegenergy-consent]"
    );

    for (var k = 0; k < deferredLinks.length; k++) {
      var link = deferredLinks[k];
      var linkCategory = link.getAttribute("data-vegenergy-consent");

      if (
        categoryAllowed(linkCategory) &&
        !link.getAttribute("href")
      ) {
        link.setAttribute("href", link.getAttribute("data-vegenergy-href"));
        link.setAttribute("data-vegenergy-consent-activated", "true");
      }
    }
  }

  function startDeferredObserver() {
    if (observer || typeof MutationObserver === "undefined") return;

    observer = new MutationObserver(function () {
      activateDeferredResources();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  function applyConsent(state, source) {
    var root = document.documentElement;
    var ids = ["preferences", "analytics", "marketing", "external"];

    for (var i = 0; i < ids.length; i++) {
      root.classList.toggle(
        "vegenergy-consent-" + ids[i],
        state.categories[ids[i]] === true
      );
    }

    activateDeferredResources();
    if (source !== "stored") {
      syncShopifyConsent(state);
    }
    dispatchConsentEvent(state, source || "stored");
  }

  /**
   * Öffnet den vorhandenen Footer-Drawer für Datenschutz/Impressum
   * und blendet den Cookie-Banner währenddessen aus.
   */
  function openLegalDrawer(title, url) {
    var footerApi = window.VegenergyFooter;
    var openFn = title === "Datenschutzerklärung" ? (footerApi && footerApi.openPrivacy) : (footerApi && footerApi.openImprint);
    var panelId = title === "Datenschutzerklärung" ? "veg-privacy-drawer" : "veg-imprint-drawer";

    if (typeof openFn !== "function") {
      window.open(url, "_blank", "noopener,noreferrer");
      return;
    }

    // Cookie-Banner sofort verstecken; der danach geöffnete Drawer übernimmt
    // synchron den globalen Overlay-Zustand.
    if (banner) {
      banner.classList.remove("veg-consent-banner--visible");
      banner.setAttribute("aria-hidden", "true");
      banner.hidden = true;
      setConsentUiOpen(false);
    }

    openFn();

    // Auf das Schließen des Drawers warten, um den Banner ggf. wieder anzuzeigen.
    // vegdrawer:close bubbled vom Panel zum document.
    var handleClose = function (e) {
      var panel = e.target;
      if (!panel || panel.id !== panelId) return;
      document.removeEventListener("vegdrawer:close", handleClose, true);
      if (!currentState) {
        showBanner();
      }
    };
    document.addEventListener("vegdrawer:close", handleClose, true);
  }

  /**
   * Fordert den bereits im Footer vorhandenen Datenschutz-Drawer an.
   * Primär wird ein cancelable Event verwendet, damit die Funktion nicht von
   * der Reihenfolge der Script-Tags abhängt. Die öffentliche Footer-API bleibt
   * als zweite Möglichkeit erhalten.
   */
  function requestFooterPrivacyDrawer() {
    try {
      var requestEvent = new CustomEvent(
        "vegenergy:open-privacy-drawer",
        {
          cancelable: true,
          detail: {
            source: "cookie-settings-footer-link",
          },
        }
      );

      if (!window.dispatchEvent(requestEvent)) {
        return true;
      }
    } catch (_) {}

    if (
      window.VegenergyFooter &&
      typeof window.VegenergyFooter.openPrivacy === "function"
    ) {
      window.VegenergyFooter.openPrivacy();
      return true;
    }

    return false;
  }

  function buildBanner() {
    var root = createElement("section", "veg-consent-banner");
    root.setAttribute("aria-labelledby", "veg-consent-banner-title");
    root.setAttribute("aria-describedby", "veg-consent-banner-text");
    root.setAttribute("role", "dialog");
    root.setAttribute("aria-modal", "false");
    root.hidden = true;

    var themeAssets = window.VegenergyThemeFooterAssets || {};
    var textureUrl =
      themeAssets.noise ||
      getAssetBase() + "noise-texture.png";
    root.style.backgroundImage =
      'url("' +
      textureUrl +
      '"), radial-gradient(ellipse 120% 100% at 0% 0%, rgba(43,65,39,0.72) 0%, rgba(36,36,36,0.96) 68%)';

    var inner = createElement("div", "veg-consent-banner__inner");
    var copy = createElement("div", "veg-consent-banner__copy");
    copy.appendChild(
      createElement("p", "veg-consent-banner__eyebrow", "Vegenergy Datenschutz")
    );

    var title = createElement(
      "h2",
      "veg-consent-banner__title",
      "Deine Privatsphäre. Deine Entscheidung."
    );
    title.id = "veg-consent-banner-title";
    copy.appendChild(title);

    var text = createElement(
      "p",
      "veg-consent-banner__text",
      "Wir verwenden technisch notwendige Technologien für den sicheren " +
        "Betrieb. Mit deiner freiwilligen Einwilligung dürfen wir außerdem " +
        "Einstellungen speichern, die Nutzung analysieren, Marketing messen " +
        "und externe Medien oder Karten laden. Du kannst ablehnen, einzeln " +
        "auswählen und deine Entscheidung jederzeit über den Footer ändern."
    );
    text.id = "veg-consent-banner-text";
    copy.appendChild(text);

    var shopNotice = createElement(
      "p",
      "veg-consent-banner__shop-notice",
      "Bitte bestätige deine bestehende Auswahl einmal für den Shop. " +
        "Shopify darf diese Entscheidung nur nach deiner direkten Aktion übernehmen."
    );
    shopNotice.hidden = true;
    shopNotice.setAttribute("data-vegenergy-shopify-confirmation", "");
    copy.appendChild(shopNotice);

    var links = createElement("div", "veg-consent-banner__links");
    var privacyBtn = createElement(
      "button",
      "veg-consent-banner__link",
      "Datenschutzerklärung"
    );
    privacyBtn.type = "button";
    privacyBtn.addEventListener("click", function () {
      openLegalDrawer("Datenschutzerklärung", PRIVACY_URL);
    });
    links.appendChild(privacyBtn);

    var imprintBtn = createElement(
      "button",
      "veg-consent-banner__link",
      "Impressum"
    );
    imprintBtn.type = "button";
    imprintBtn.addEventListener("click", function () {
      openLegalDrawer("Impressum", IMPRINT_URL);
    });
    links.appendChild(imprintBtn);
    copy.appendChild(links);

    var actions = createElement("div", "veg-consent-banner__actions");
    var accept = createElement(
      "button",
      "veg-consent-button",
      "Alle akzeptieren"
    );
    accept.type = "button";
    accept.addEventListener("click", function () {
      setConsent(defaultCategories(true), "accept-all");
    });
    actions.appendChild(accept);

    var reject = createElement(
      "button",
      "veg-consent-button",
      "Alle ablehnen"
    );
    reject.type = "button";
    reject.addEventListener("click", function () {
      setConsent(defaultCategories(false), "reject-all");
    });
    actions.appendChild(reject);

    var settings = createElement(
      "button",
      "veg-consent-button veg-consent-button--settings",
      "Einstellungen im Detail"
    );
    settings.type = "button";
    settings.addEventListener("click", function () {
      hideBanner();
      openSettings();
    });
    actions.appendChild(settings);

    inner.appendChild(copy);
    inner.appendChild(actions);
    root.appendChild(inner);
    document.body.appendChild(root);

    return root;
  }

  function showBanner(reason) {
    if (!banner) banner = buildBanner();

    var shopNotice = banner.querySelector(
      "[data-vegenergy-shopify-confirmation]"
    );
    if (shopNotice) {
      shopNotice.hidden = reason !== "shopify-confirmation";
    }

    banner.hidden = false;
    banner.removeAttribute("aria-hidden");
    setConsentUiOpen(true);

    window.requestAnimationFrame(function () {
      banner.classList.add("veg-consent-banner--visible");
    });
  }

  function hideBanner() {
    if (!banner) return;
    banner.classList.remove("veg-consent-banner--visible");
    banner.setAttribute("aria-hidden", "true");

    window.setTimeout(function () {
      if (!banner.classList.contains("veg-consent-banner--visible")) {
        banner.hidden = true;
        setConsentUiOpen(false);
      }
    }, 340);
  }

  function createFact(label, value) {
    var fact = createElement("div", "veg-consent-fact");
    fact.appendChild(
      createElement("span", "veg-consent-fact__label", label)
    );
    fact.appendChild(
      createElement("span", "veg-consent-fact__value", value)
    );
    return fact;
  }

  function createCategoryCard(category, draft) {
    var card = createElement("article", "veg-consent-category");
    var main = createElement("div", "veg-consent-category__main");
    var copy = createElement("div", "veg-consent-category__copy");
    var titleRow = createElement("div", "veg-consent-category__title-row");

    var title = createElement(
      "h4",
      "veg-consent-category__title",
      category.title
    );
    titleRow.appendChild(title);
    titleRow.appendChild(
      createElement("span", "veg-consent-category__badge", category.badge)
    );
    copy.appendChild(titleRow);
    copy.appendChild(
      createElement("p", "veg-consent-category__summary", category.summary)
    );
    main.appendChild(copy);

    var toggle = createElement("label", "veg-consent-toggle");
    toggle.setAttribute(
      "aria-label",
      category.required
        ? category.title + " sind immer aktiv"
        : category.title + " zulassen"
    );

    var input = createElement("input", "veg-consent-toggle__input");
    input.type = "checkbox";
    input.id = "veg-consent-category-" + category.id;
    input.setAttribute("data-vegenergy-consent-category", category.id);
    input.checked = category.required || draft[category.id] === true;
    input.disabled = category.required;
    toggle.appendChild(input);
    toggle.appendChild(createElement("span", "veg-consent-toggle__track"));
    main.appendChild(toggle);
    card.appendChild(main);

    var details = createElement("details", "veg-consent-category__details");
    var summary = createElement("summary", null, "Zwecke und Dienste anzeigen");
    details.appendChild(summary);

    var detailsBody = createElement(
      "div",
      "veg-consent-category__details-body"
    );
    var facts = createElement("div", "veg-consent-facts");
    facts.appendChild(createFact("Zweck", category.purpose));
    facts.appendChild(createFact("Rechtsgrundlage", category.legal));
    facts.appendChild(createFact("Speicherung", category.storage));
    detailsBody.appendChild(facts);

    var services = createElement("ul", "veg-consent-service-list");
    for (var i = 0; i < category.services.length; i++) {
      var service = category.services[i];
      var item = createElement("li", "veg-consent-service");
      var serviceHeading = createElement("div");
      serviceHeading.appendChild(
        createElement("div", "veg-consent-service__name", service.name)
      );
      serviceHeading.appendChild(
        createElement("div", "veg-consent-service__meta", service.host)
      );
      item.appendChild(serviceHeading);
      item.appendChild(
        createElement(
          "p",
          "veg-consent-service__description",
          service.description
        )
      );
      services.appendChild(item);
    }
    detailsBody.appendChild(services);
    details.appendChild(detailsBody);
    card.appendChild(details);

    return card;
  }

  function getDraftFromSettings(content) {
    var draft = defaultCategories(false);
    var inputs = content.querySelectorAll(
      "[data-vegenergy-consent-category]"
    );

    for (var i = 0; i < inputs.length; i++) {
      var category = inputs[i].getAttribute(
        "data-vegenergy-consent-category"
      );
      draft[category] = inputs[i].checked === true;
    }

    draft.necessary = true;
    return draft;
  }

  function buildSettingsContent() {
    var draft = currentState
      ? Object.assign({}, currentState.categories)
      : defaultCategories(false);
    var content = createElement("div", "veg-consent-settings");
    var intro = createElement("div", "veg-consent-settings__intro");

    intro.appendChild(
      createElement(
        "p",
        "veg-consent-settings__eyebrow",
        "Cookie- und Datenschutz-Einstellungen"
      )
    );
    intro.appendChild(
      createElement(
        "h2",
        "veg-consent-settings__title",
        "Du entscheidest, welche Technologien aktiv sein dürfen."
      )
    );
    intro.appendChild(
      createElement(
        "p",
        "veg-consent-settings__lead",
        "Technisch notwendige Funktionen sind immer aktiv. Alle anderen " +
          "Kategorien sind freiwillig und standardmäßig ausgeschaltet, bis " +
          "du zustimmst. Die Auswahl gilt zentral für vegenergy.at, shop, " +
          "blog, now und finder. Ein Widerruf wirkt für die Zukunft."
      )
    );

    var notice = createElement("div", "veg-consent-settings__notice");
    notice.appendChild(
      createElement("span", "veg-consent-settings__notice-icon", "i")
    );
    notice.appendChild(
      createElement(
        "span",
        null,
        "Externe Dienste können bereits beim Laden IP-Adresse, Browser- und " +
          "Verbindungsdaten erhalten. Deshalb müssen die jeweiligen Seiten " +
          "optionale Skripte, Karten und Einbettungen technisch an diese " +
          "Auswahl koppeln."
      )
    );
    intro.appendChild(notice);
    content.appendChild(intro);

    var actions = createElement("div", "veg-consent-settings__actions");
    var accept = createElement(
      "button",
      "veg-consent-button",
      "Alle akzeptieren"
    );
    accept.type = "button";
    accept.addEventListener("click", function () {
      setConsent(defaultCategories(true), "accept-all");
    });
    actions.appendChild(accept);

    var reject = createElement(
      "button",
      "veg-consent-button",
      "Alle ablehnen"
    );
    reject.type = "button";
    reject.addEventListener("click", function () {
      setConsent(defaultCategories(false), "reject-all");
    });
    actions.appendChild(reject);

    var save = createElement(
      "button",
      "veg-consent-button",
      "Auswahl speichern"
    );
    save.type = "button";
    save.addEventListener("click", function () {
      setConsent(getDraftFromSettings(content), "save-selection");
    });
    actions.appendChild(save);
    content.appendChild(actions);

    content.appendChild(
      createElement(
        "h3",
        "veg-consent-settings__section-heading",
        "Kategorien und aktuell erkannte Dienste"
      )
    );

    var categoryList = createElement("div", "veg-consent-category-list");
    for (var i = 0; i < CATEGORIES.length; i++) {
      categoryList.appendChild(createCategoryCard(CATEGORIES[i], draft));
    }
    content.appendChild(categoryList);

    var footer = createElement("div", "veg-consent-settings__footer");
    footer.appendChild(
      document.createTextNode(
        "Verantwortlich: Pro Product Concept GmbH, Margeritenweg 8, " +
          "4052 Ansfelden, Österreich. Kontakt: info@vegenergy.at. " +
          "Deine Einwilligung ist freiwillig und jederzeit ohne Angabe von " +
          "Gründen widerrufbar. Der Widerruf berührt nicht die Rechtmäßigkeit " +
          "der bis dahin erfolgten Verarbeitung. Weitere Angaben zu " +
          "Empfängern, Übermittlungen und Betroffenenrechten findest du in der "
      )
    );

    var privacyBtn2 = createElement("button", "veg-consent-settings__footer-link", "Datenschutzerklärung");
    privacyBtn2.type = "button";
    privacyBtn2.setAttribute(
      "data-vegenergy-open-footer-privacy",
      ""
    );
    privacyBtn2.addEventListener("click", function () {
      /*
       * Den Cookie-Drawer über seine öffentliche API schließen. Dadurch
       * bleiben Fokus-Trap, Body-Scroll und ARIA-Zustände korrekt, ohne
       * interne Drawer-Eigenschaften direkt zu verändern.
       */
      suppressSettingsOnClose = true;

      // Nach dem Datenschutz-Drawer wieder in die Cookie-Einstellungen zurück.
      var onPrivacyClosed = function (e) {
        if (!e.target || e.target.id !== "veg-privacy-drawer") return;

        document.removeEventListener("vegdrawer:close", onPrivacyClosed, true);
        suppressSettingsOnClose = false;

        window.setTimeout(function () {
          if (settingsDrawer) settingsDrawer.open();
        }, 0);
      };
      document.addEventListener("vegdrawer:close", onPrivacyClosed, true);

      if (settingsDrawer && settingsDrawer.isOpen()) {
        settingsDrawer.close(true);
      }

      if (!requestFooterPrivacyDrawer()) {
        document.removeEventListener(
          "vegdrawer:close",
          onPrivacyClosed,
          true
        );
        suppressSettingsOnClose = false;
        showStatus(
          "Der Datenschutz-Drawer ist noch nicht verfügbar. " +
            "Bitte lade footer.js und footer-drawer.js neu."
        );

        if (settingsDrawer) {
          settingsDrawer.open(true);
        }
      }
    });
    footer.appendChild(privacyBtn2);
    footer.appendChild(document.createTextNode("."));
    content.appendChild(footer);

    return content;
  }

  function openSettings() {
    hideBanner();

    if (typeof window.VegenergyDrawer !== "function") {
      showBanner();
      showStatus(
        "Die Detailansicht konnte nicht geladen werden. Bitte lade die Seite neu."
      );
      return;
    }

    var content = buildSettingsContent();

    if (!settingsDrawer) {
      settingsDrawer = new window.VegenergyDrawer({
        id: "veg-cookie-settings-drawer",
        title: "Cookie- und Datenschutz-Einstellungen",
        content: content,
        onClose: function () {
          if (suppressSettingsOnClose) return;
          if (!readConsent()) showBanner();
        },
      });

      settingsDrawer
        .getPanel()
        .classList.add("veg-consent-drawer");
    } else {
      settingsDrawer.setContent(content);
    }

    settingsDrawer.open();
  }

  function init() {
    if (!isActualShop) {
      document.documentElement.classList.add("vegenergy-consent-manager");
    }

    if (isLocalPreview()) {
      try {
        if (new URLSearchParams(window.location.search).get("resetConsent") === "1") {
          deleteConsent();
        }
      } catch (_) {}
    }

    currentState = readConsent();
    startDeferredObserver();

    if (currentState) {
      applyConsent(currentState, "stored");
    } else {
      showBanner();
    }

    if (isActualShop) {
      initializeShopifyIntegration();
    }

    try {
      window.dispatchEvent(
        new CustomEvent("vegenergy:consent-ready", {
          detail: {
            version: CONSENT_VERSION,
            hasDecision: !!currentState,
            categories: currentState
              ? Object.assign({}, currentState.categories)
              : defaultCategories(false),
          },
        })
      );
    } catch (_) {}
  }

  window.addEventListener(
    "vegenergy:open-cookie-settings",
    function (event) {
      if (event && typeof event.preventDefault === "function") {
        event.preventDefault();
      }
      openSettings();
    }
  );

  window.VegenergyConsent = {
    version: CONSENT_VERSION,
    openSettings: openSettings,
    acceptAll: function () {
      setConsent(defaultCategories(true), "accept-all");
    },
    rejectAll: function () {
      setConsent(defaultCategories(false), "reject-all");
    },
    save: function (categories) {
      setConsent(categories || defaultCategories(false), "api");
    },
    getConsent: function () {
      return currentState
        ? JSON.parse(JSON.stringify(currentState))
        : null;
    },
    has: function (category) {
      return categoryAllowed(category);
    },
    reset: function () {
      deleteConsent();
      currentState = null;
      showBanner();
    },
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
